import { render, staticRenderFns } from "./CotacaoDetalhesCard.vue?vue&type=template&id=3caff9b1"
import script from "./CotacaoDetalhesCard.vue?vue&type=script&lang=js"
export * from "./CotacaoDetalhesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports